import { TasksListGroup } from 'app/agriculture/routes/Tasks/TaskList/components/TasksListGroup/TasksListGroup';
import { MonthIcon } from 'app/agriculture/routes/Tasks/TaskList/components/MonthIcon/MonthIcon';
import { isSameMonth } from 'date-fns';
import { Task } from 'app/agriculture/queries/tasks/types/Task';

interface AllTasksMonthViewProps {
    tasks: Task[];
}

export function TaskListMonthView({ tasks }: AllTasksMonthViewProps) {
    if (tasks.length === 0) {
        return null;
    }

    const numberOfVisibleMonths = 6;

    const date = new Date();
    // an undefined locale defaults to the browser's default locale
    const locale = undefined;
    const dateFormat = new Intl.DateTimeFormat(locale, {
        month: 'long',
        year: 'numeric',
    });

    const pastTasks = tasks.filter(
        ({ startDate }) => startDate < date && !isSameMonth(startDate, date),
    );

    const futureDate = new Date(date.getFullYear(), date.getMonth() + numberOfVisibleMonths - 1);

    const futureTasks = tasks.filter(
        ({ startDate }) => startDate > futureDate && !isSameMonth(startDate, futureDate),
    );

    return (
        <>
            <TasksListGroup title="Past" icon={<MonthIcon month="<<" />} tasks={pastTasks} />
            {Array.from({ length: numberOfVisibleMonths }, (_, i) => {
                const month = date.getMonth();
                const year = date.getFullYear();
                const title = dateFormat.format(date);
                date.setMonth(month + 1);
                const isCurrentMonth = i === 0;

                const thisMonthsTasks = tasks.filter(
                    ({ startDate }) =>
                        startDate.getMonth() === month && startDate.getFullYear() === year,
                );

                if (thisMonthsTasks.length === 0) {
                    return null;
                }

                return (
                    <TasksListGroup
                        key={title}
                        title={title}
                        icon={<MonthIcon month={month + 1} />}
                        tasks={thisMonthsTasks}
                        startExpanded={isCurrentMonth}
                    />
                );
            })}
            <TasksListGroup title="Future" icon={<MonthIcon month=">>" />} tasks={futureTasks} />
        </>
    );
}
